/**
 * Admin Global Discount Data Fetching Hooks
 *
 * Custom hooks using React Query for fetching and mutating the global discount.
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { deactivateGlobalDiscount, fetchGlobalDiscount, upsertGlobalDiscount } from "../utils/adminApi";

export const GLOBAL_DISCOUNT_QUERY_KEY = ["admin", "global-discount"];

export const useGlobalDiscount = () => {
  return useQuery({
    queryKey: GLOBAL_DISCOUNT_QUERY_KEY,
    queryFn: () => fetchGlobalDiscount(),
    refetchOnWindowFocus: false,
  });
};

export const useUpsertGlobalDiscount = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => upsertGlobalDiscount(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: GLOBAL_DISCOUNT_QUERY_KEY });
    },
  });
};

export const useDeactivateGlobalDiscount = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => deactivateGlobalDiscount(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: GLOBAL_DISCOUNT_QUERY_KEY });
    },
  });
};


